import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DynamicScreens } from '@cashier/cashier-model';

export interface CustomerInformation {
  activeScreen: DynamicScreens;
  balance: string | null;
  bonusCode: string;
}

export interface InitialiseParamsAboutCustomer {
  balance: string | null;
  bonusCode: string;
}

export const CUSTOMER_INFORMATION_KEY = 'customerInformation';

export const initialCustomerInformationState: CustomerInformation = {
  balance: null,
  activeScreen: DynamicScreens.PaymentForm,
  bonusCode: '',
};

export const customerInformationSlice = createSlice({
  name: CUSTOMER_INFORMATION_KEY,
  initialState: initialCustomerInformationState,
  reducers: {
    initialiseCustomer: (
      state,
      { payload }: PayloadAction<InitialiseParamsAboutCustomer>,
    ) => {
      state.balance = payload.balance;
      state.bonusCode = payload.bonusCode;
    },
    setActiveScreen: (state, { payload }: PayloadAction<DynamicScreens>) => {
      state.activeScreen = payload;
    },
    setBalance: (state, { payload }: PayloadAction<string>) => {
      state.balance = payload;
    },
    setBonusCode: (state, { payload }: PayloadAction<string>) => {
      state.bonusCode = payload;
    },
  },
});

export const customerInformationReducer = customerInformationSlice.reducer;
export const { initialiseCustomer, setActiveScreen, setBalance, setBonusCode } =
  customerInformationSlice.actions;
